import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import a from "./index289.js";
const n = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, o, p, m, f, h) {
  return e(), t("svg", l, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M14.5 3.25a2.25 2.25 0 0 1 2.25 2.25v1.75h1.75a2.25 2.25 0 0 1 2.245 2.096l.005.154V17A3.75 3.75 0 0 1 17 20.75H7A3.75 3.75 0 0 1 3.25 17V9.5A2.25 2.25 0 0 1 5.5 7.25h1.75V5.5a2.25 2.25 0 0 1 2.096-2.245L9.5 3.25Zm4.75 9.769-6.579 2.057a2.25 2.25 0 0 1-1.342 0l-6.58-2.057L4.75 17a2.25 2.25 0 0 0 2.096 2.245L7 19.25h10A2.25 2.25 0 0 0 19.25 17v-3.981ZM18.5 8.75h-13a.75.75 0 0 0-.75.75v1.949l7.026 2.195a.75.75 0 0 0 .448 0l7.026-2.196V9.5a.75.75 0 0 0-.648-.743L18.5 8.75Zm-4-4h-5a.75.75 0 0 0-.75.75v1.75h6.5V5.5a.75.75 0 0 0-.648-.743L14.5 4.75Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ a(n, [["render", s]]);
export {
  d as default
};
